import React from 'react';
import ModalContainer from 'components/shared/modal/modal_container';
import RenderInBody from 'components/shared/render_in_body';
import { Button, ButtonGroup } from 'ui';
import { Text, TEXT_VARIANTS } from 'components/ui/Typography';
import { routes } from 'constants/config';
import { X } from 'react-feather';

const ExitAddProfileModal = ({ shouldSave, saveProfile, closeModal }) => {
  return (
    <RenderInBody>
      <ModalContainer
        className="ModalTakeover-background Modal-background d-f ai-c"
        onEscape={closeModal}
      >
        {!shouldSave && (
          <div className="ModalTakeover-container w-55p">
            <div className="TemplateCreationModal-body">
              <div className="TemplateCreationModal-title">
                {t('common.are_you_sure')}
              </div>
              <div className="mt-16">
                <Text variant={TEXT_VARIANTS.BODY}>
                  {t('skills.confirm_profile_exit')}
                </Text>
              </div>
              <div className="mt-24">
                <ButtonGroup alignEnd>
                  <Button type="cancel" onClick={closeModal}>
                    {t('common.no')}
                  </Button>
                  <Button
                    className="Button--danger"
                    onClick={() => {
                      window.location.href = routes.SKILLS.PROFILES;
                    }}
                  >
                    {t('common.yes')}
                  </Button>
                </ButtonGroup>
              </div>
              <button
                type="button"
                aria-label={t('common.close')}
                className="u-resetBtn ModalTakeover-closeButton"
                onClick={closeModal}
              >
                <X />
              </button>
            </div>
          </div>
        )}
      </ModalContainer>
    </RenderInBody>
  );
};

export default ExitAddProfileModal;
